import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { Paginated } from './paginated';
import type { PortalActivityData } from '@/types/api';

/** Curated client-facing activity feed (outbound events only, server-filtered). */
export function usePortalActivity(page = 1) {
  return useQuery({
    queryKey: ['portal-activity', page],
    queryFn: async (): Promise<Paginated<PortalActivityData>> => {
      const { data } = await api.get<Paginated<PortalActivityData>>('/v1/portal/activity', {
        params: { page },
      });
      return data;
    },
  });
}
